import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Box, Button } from '@mui/material';
import IncodeOnboardingPopup from './IncodeOnboardingPopup';
import StatusPopup from './StatusPopup';

export const LinesPageDialogs = ({
  dialogTitleMessage,
  dialogMessage,
  icon,
  isDialogOpen,
  handleClose,
  isIncodeStatusDialogLocked,
  aditionalInfoDialog,
  pendingRemoveLine,
  formatPhoneNumber,
  isRemoveDialogOpen,
  handleCloseRemoveDialog,
  handleConfirmRemoveLine,
  loading,
  isIncodeDialogOpen,
  handleCloseIncodeDialog,
  incodeLinksDialog,
  incodeLinksLoading,
  getIncodeStatusExecute,
}) => {
  return (
    <>
      <StatusPopup
        title={dialogTitleMessage}
        decription={dialogMessage}
        icon={icon}
        open={isDialogOpen}
        onClose={handleClose}
        showCloseButton={!isIncodeStatusDialogLocked}
        disableClose={isIncodeStatusDialogLocked}
        aditionalInfoDialog={aditionalInfoDialog}
      />

      <StatusPopup
        title='¿Deseas eliminar la línea?'
        decription={`La línea ${formatPhoneNumber(pendingRemoveLine)}`}
        icon={<DeleteOutlineOutlinedIcon sx={{ fontSize: 40, color: '#D32F2F' }} />}
        open={isRemoveDialogOpen}
        onClose={handleCloseRemoveDialog}
        aditionalInfoDialog={
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
            <Button
              onClick={handleCloseRemoveDialog}
              variant='text'
              sx={{
                '&:hover': {
                  backgroundColor: 'transparent',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
                },
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={handleConfirmRemoveLine}
              variant='text'
              sx={{
                color: '#D32F2F',
                '&:hover': {
                  backgroundColor: 'transparent',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
                },
              }}
              disabled={loading}
            >
              Sí, eliminar
            </Button>
          </Box>
        }
      />

      <IncodeOnboardingPopup
        open={isIncodeDialogOpen}
        onClose={handleCloseIncodeDialog}
        incodeLinksDialog={incodeLinksDialog}
        incodeLinksLoading={incodeLinksLoading}
        getIncodeStatusExecute={getIncodeStatusExecute}
      />
    </>
  );
};
